// extracted by mini-css-extract-plugin
module.exports = {"scopeCell":"style_scopeCell__1RAVfTg4ko202QGrGhGk6a","defineScope":"style_defineScope__ZXa8q2R9XG44c3jfee0Fs"};